import accordion from '../features/accordion';
import {register} from '../vendor/theme-scripts/theme-sections';

register('accordion-single', accordion);
